import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
import store from '../store';
import router from '../router';
import { getToken } from '../js/tool';

// 封装警告提示，过滤重复警告
let prevErrorMsg = "";
let MSG = (str) => {
    if (str === prevErrorMsg) {
        return false;
    } else {
        prevErrorMsg = str;
        Message.error({
            customClass: "top-layer",
            message: str
        });
        setTimeout(() => {
            prevErrorMsg = ""
        }, 3000);
    }
}

axios.defaults.baseURL = process.env.VUE_APP_APIROOT;
axios.defaults.headers.common['X-Fanyun-api-version'] = process.env.VUE_APP_VERSION;
// axios.defaults.headers.common['Authorization'] = "Bearer " + getToken(); // 这将导致不能实时刷新请求中的token

//  REQUEST 请求拦截
axios.interceptors.request.use(config => {
    //==========  所有请求之前都要执行的操作  ==============
    return config;
}, err => {
    // Message.error("request错误");
    //==================  错误处理  ====================
    // Message.error({ message: '请求超时!' });
    return Promise.resolve(err);
})

//  RESPONSE 响应拦截
axios.interceptors.response.use(data => {
    // Status Code 为200 进此逻辑
    //==============  Status Code为200 时，所有请求完成后都要执行的操作  ==================
    let DATA = data.data;
    
    // 检查是否为登录相关的消息
    const errorMsg = DATA.msg || DATA.message || '';
    if (errorMsg.includes('其他设备登录') || errorMsg.includes('重新登录') || errorMsg.includes('请先登录')) {
        MSG(errorMsg);
        localStorage.clear();
        store.commit("logout");
        
        // 通知父项目刷新页面（无论是iframe还是通过window.open打开的窗口）
        if (window.parent !== window) {
            // 在iframe中，发送消息给父项目
            try {
                window.parent.postMessage({ type: 'logout' }, '*');
                console.log('已向父项目发送登录过期消息(iframe)');
            } catch (e) {
                console.log('发送登录过期消息失败:', e);
            }
        } else if (window.opener) {
            // 通过window.open打开的窗口，发送消息给opener
            try {
                window.opener.postMessage({ type: 'logout' }, '*');
                console.log('已向父窗口发送登录过期消息(opener)');
            } catch (e) {
                console.log('发送登录过期消息失败:', e);
            }
        }
        
        router.replace({ name: 'Login' });
        return Promise.reject(DATA);
    }
    
    // 检查是否是头像接口，如果是，不显示错误信息
    const isAvatarApi = data.config && (data.config.url === 'api/v1/customers/logo' || data.config.url === 'api/v1/accounts/me/avatar');
    
    // 根据返回的code值来做不同的处理（和后端约定）
    switch (DATA.code) {
        // 正常响应
        case 200:
            // 这一步保证数据返回，如果没有return则会走接下来的代码，不是未登录就是报错。这里直接返回需要的数据
            if (DATA.isSuccess) {
                return DATA;
            } else {
                return Promise.reject(DATA);
            }
        case 400:
            if (!isAvatarApi) {
                MSG(DATA.msg);
            }
            return Promise.reject(DATA);
        // 未登录为401
        case 401:
            if (!isAvatarApi) {
                MSG(DATA.msg);
            }
            localStorage.clear();
            store.commit("logout");
            
            // 通知父项目刷新页面（无论是iframe还是通过window.open打开的窗口）
            if (window.parent !== window) {
                // 在iframe中，发送消息给父项目
                try {
                    window.parent.postMessage({ type: 'logout' }, '*');
                    console.log('已向父项目发送401登录过期消息(iframe)');
                } catch (e) {
                    console.log('发送401登录过期消息失败:', e);
                }
            } else if (window.opener) {
                // 通过window.open打开的窗口，发送消息给opener
                try {
                    window.opener.postMessage({ type: 'logout' }, '*');
                    console.log('已向父窗口发送401登录过期消息(opener)');
                } catch (e) {
                    console.log('发送401登录过期消息失败:', e);
                }
            }
            
            router.replace({ name: 'Login' })
            break;
        // 
        case 404:
            if (!isAvatarApi) {
                MSG(DATA.msg);
            }
            break;
        // 服务器错误
        case 500:
            if (!isAvatarApi) {
                MSG(DATA.msg);
            }
            return Promise.reject(DATA);
        // break;

        default:
    }
    // 若不是正确的返回code，且已经登录，就抛出错误

    return data;
}, (err) => {
    //==============  错误处理  ====================
    let res;
    if (err && err.response) {
        res = err.response;
        
        // 检查是否是头像接口，如果是，不显示错误信息
        const isAvatarApi = err.config && (err.config.url === 'api/v1/customers/logo' || err.config.url === 'api/v1/accounts/me/avatar');
        
        // 检查错误消息是否包含登录相关的提示
        const errorMsg = res.data.msg || res.data.message || '';
        if (errorMsg.includes('其他设备登录') || errorMsg.includes('重新登录') || errorMsg.includes('请先登录')) {
            MSG(errorMsg);
            localStorage.clear();
            store.commit("logout");
            
            // 通知父项目刷新页面（无论是iframe还是通过window.open打开的窗口）
            if (window.parent !== window) {
                // 在iframe中，发送消息给父项目
                try {
                    window.parent.postMessage({ type: 'logout' }, '*');
                    console.log('已向父项目发送登录过期消息(错误响应-iframe)');
                } catch (e) {
                    console.log('发送登录过期消息失败:', e);
                }
            } else if (window.opener) {
                // 通过window.open打开的窗口，发送消息给opener
                try {
                    window.opener.postMessage({ type: 'logout' }, '*');
                    console.log('已向父窗口发送登录过期消息(错误响应-opener)');
                } catch (e) {
                    console.log('发送登录过期消息失败:', e);
                }
            }
            
            router.replace({ name: 'Login' });
            return Promise.reject(err);
        }
        
        // res.my_mark = "hrt";
        switch (err.response.status) {
            case 400:
                if (!isAvatarApi) {
                    MSG(res.data.msg);
                }

                break;
            //     case 401: err.message = '未授权，请重新登录(401)'; break;
            //     case 403: err.message = '拒绝访问(403)'; break;
            //     case 404: err.message = '请求出错(404)'; break;
            //     case 408: err.message = '请求超时(408)'; break;
            case 500:
                err.message = '服务器错误(500)';
                if (!isAvatarApi && res.data.msg) MSG(res.data.msg);
                if (res.data.code === 401) {
                    localStorage.clear();
                    store.commit("logout");
                    router.replace({ name: 'Login' })
                }
                break;
            //     case 501: err.message = '服务未实现(501)'; break;
            //     case 502: err.message = '网络错误(502)'; break;
            //     case 503: err.message = '服务不可用(503)'; break;
            //     case 504: err.message = '网络超时(504)'; break;
            //     case 505: err.message = 'HTTP版本不受支持(505)'; break;
            default:
                err.message = `连接出错(${err.response.status})!`;
                if (!isAvatarApi) {
                    MSG(res.data.msg);
                }
        }
    } else {
        // 检查是否是头像接口，如果是，不显示错误信息
        const isAvatarApi = err.config && (err.config.url === 'api/v1/customers/logo' || err.config.url === 'api/v1/accounts/me/avatar');
        if (!isAvatarApi) {
            MSG('连接服务器失败');
        }
    }
    // return Promise.resolve(err);
    // return Promise.reject(err); // reject则在实际请求时能通过.catch方法捕获
    
    return Promise.reject(res.data); // reject则在实际请求时能通过.catch方法捕获
})

// get请求方法：config为可选参数，只传入2个参数时，第二个参数作为params处理
export const Get = function (url, config, params) {
    if (!params) {
        params = config;
        config = {};
    }
    return axios({
        method: 'get',
        url,
        params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        },
        headers: { 'Authorization': "Bearer " + getToken() },
        ...config
    })
}

// post请求方法
export const Post = function (url, config, params) {
    if (!params) {
        params = config;
        config = {};
    }
    return axios({
        method: 'post',
        url,
        data: params,
        headers: { 
            'Authorization': "Bearer " + getToken(),
            'Content-Type': 'application/json'
        },
        ...config
    })
}

// 下载文件
export const Download = function (url, params, fileName) {
    // 过滤空值参数
    const filteredParams = {};
    if (params) {
        for (const key in params) {
            if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
                filteredParams[key] = params[key];
            }
        }
    }
    
    return axios({
        method: 'get',
        url,
        params: filteredParams,
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        },
        headers: { 'Authorization': "Bearer " + getToken() },
        responseType: "arraybuffer",
    }).then((res) => {
        const blob = new Blob([res.data], {
            type: "application/zip;charset=utf-8"
        });
        if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
        } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
        }
        return res;
    }).catch(err => {
        // 处理下载错误
        if (err.response && err.response.data) {
            try {
                // 将arrayBuffer转为对象
                var enc = new TextDecoder('utf-8');
                var res = JSON.parse(enc.decode(new Uint8Array(err.response.data)));
                MSG(res.msg || res.message || '下载失败');
            } catch (e) {
                MSG('下载失败');
            }
        } else {
            MSG(err.msg || err.message || '下载失败');
        }
    })
}

// 刪除
export const Delete = function (url, config, params) {
    if (!params) {
        params = config;
        config = {};
    }
    return axios({
        method: 'delete',
        url,
        params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        },
        headers: { 'Authorization': "Bearer " + getToken() },
        ...config
    })
}

// put请求方法
export const Put = function (url, config, params) {
    if (!params) {
        params = config;
        config = {};
    }
    return axios({
        method: 'put',
        url,
        data: params,
        headers: { 
            'Authorization': "Bearer " + getToken(),
            'Content-Type': 'application/json'
        },
        ...config
    })
}

// patch请求方法
export const Patch = function (url, config, params) {
    if (!params) {
        params = config;
        config = {};
    }
    return axios({
        method: 'patch',
        url,
        data: params,
        headers: { 
            'Authorization': "Bearer " + getToken(),
            'Content-Type': 'application/json'
        },
        ...config
    })
}
